import { Component, OnInit, HostListener, ViewChild, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { ActivatedRoute, Params, Router, NavigationStart } from '@angular/router';
import { WpapiService } from 'src/app/services/wpapi.service';
import { Subject } from "rxjs";
import { throttleTime } from 'rxjs/operators';
import { BannerModuleComponent } from '../../modules/banner-module/banner-module.component';
import { AnimationService } from 'src/app/services/animation.service';
import { PageService } from 'src/app/services/page.service';
import { RelatedPostsComponent } from '../../modules/related-posts/related-posts.component';
import { RelatedOverlayComponent } from '../../modules/related-overlay/related-overlay.component';
import { fadeAnimation } from 'src/app/animations/animation';
import { SeoService } from 'src/app/services/seo.service';

export enum KEY_CODE {
    UP_ARROW = 38,
    DOWN_ARROW = 40
}

@Component({
    selector: 'app-single-work',
    templateUrl: './single-work.component.html',
    styleUrls: ['./single-work.component.scss'],
    animations: [fadeAnimation]
})

export class SingleWorkComponent implements OnInit {
    slug: string;
    id: number;
    image: any;
    pageCounterValue = 0;
    pageCounter = 0;
    counter: number = 0;
    screenHeight;
    screenWidth;
    scrollHeight;
    postColor: any;
    modules: any;
    transformNextPage: boolean = false;
    transformPrevPage: boolean = false;
    tags: any;
    tagstitle: any;
    title: string;
    subtitle: string;
    menuActive = false;
    activeindex: number = 0;
    nextPostActive: boolean = false;
    transitionAnimation: boolean = true;
    pausescroll: boolean = false;
    isMac = navigator.platform;
    logo: string;
    activateRelatedOverlay: boolean = false;
    animatePage: boolean = false;
    animateFromRelated: boolean = false;
    @ViewChild('related') related: RelatedPostsComponent;
    @ViewChild('bannermodule') bannermodule: BannerModuleComponent;
    @ViewChild('relatedOverlay') relatedOverlay: RelatedOverlayComponent;
    @ViewChild('gridcontainer', { static: true }) gridcontainer: ElementRef;
    private SubjectUp = new Subject<number>();
    private SubjectDown = new Subject<number>();
    private SubjectUpMac = new Subject<number>();
    private SubjectDownMac = new Subject<number>();
    activateMenuOverlay: boolean = false;
    isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
    videoPlaying: boolean = false;

    constructor(private route: ActivatedRoute,
        private wpApi: WpapiService,
        private router: Router,
        private animationService: AnimationService,
        private pageService: PageService,
        private seoService: SeoService
    ) {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth <= 1024) {
            this.screenHeight = window.innerHeight;
        } else {
            this.screenHeight = document.getElementById('main-container-wrapper').clientHeight;
        }
        this.pageService.listen().subscribe((m: boolean) => {
            this.onMenuActive(m);
        })
        this.pageService.goToTopListen().subscribe(() => {
            if (this.isIPadPro && this.screenWidth > 1024) {
                const grid = document.getElementById('main-container-wrapper');
                grid.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                this.counter = 0;
            }
        })
        this.pageService.animateSingleListen().subscribe(() => {
            this.animateFromRelated = true;
        })
        this.pageService.activateMenuOverlayListen().subscribe((resp) => {
            this.activateMenuOverlay = resp;
        })
        this.pageService.mobileVideoPlayingListen().subscribe((resp) => {
            this.videoPlaying = resp;
        })
    }

    onMenuActive(m) {
        this.menuActive = m;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth <= 1024) {
            this.screenHeight = window.innerHeight;
        } else {
            this.screenHeight = document.getElementById('main-container-wrapper').clientHeight;
        }

        if (this.screenWidth > 767) {
            this.pageCounter = Math.floor(this.pageCounterValue / 8);
        } else {
            this.pageCounter = Math.ceil(this.pageCounterValue / 2);
        }
        this.scrollHeight = (this.pageCounter + 2) * this.screenHeight;
        this.counter = 0;
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        if (event.srcElement.location.pathname === '/' || event.srcElement.location.pathname === '/works' || event.srcElement.location.pathname === '/search') {
            this.animateBack();
        } else {
            // const slug = event.srcElement.location.pathname.split('/')[2];
            // this.handleNextPrevPost(slug);
            const body = document.getElementsByTagName('body')[0];
            body.classList.add('body-overlay');
            setTimeout(() => {
                body.classList.remove('body-overlay');
            }, 1000);
        }
    }

    @HostListener('window:scroll', ['$event'])
    onScroll(event) {
        if (this.screenWidth <= 1024) {
            if (document.documentElement.scrollTop > this.screenHeight) {
                this.bannermodule.logocheckactive = false;
                this.bannermodule.menucheckactive = false;
            } else {
                this.bannermodule.logocheckactive = true;
                this.bannermodule.menucheckactive = true;
            }
        }
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.keyCode === KEY_CODE.UP_ARROW) {
            this.onScrollUp();
        }
        if (event.keyCode === KEY_CODE.DOWN_ARROW) {
            this.onScrollDown();
        }
    }

    animateBack() {
        this.bannermodule.setImageOverlayModule();
        this.animationService.animationCalled(this.slug);
    }

    ngOnInit() {
        this.SubjectUp.asObservable()
            .pipe(
                throttleTime(200)
            ).subscribe(x => this.doSomethingWithThrottledEventUp(x));

        this.SubjectDown.asObservable()
            .pipe(
                throttleTime(200)
            ).subscribe(x => this.doSomethingWithThrottledEventDown(x));

        this.SubjectUpMac.asObservable()
            .pipe(
                throttleTime(500)
            ).subscribe(x => this.doSomethingWithThrottledEventUpMac(x));

        this.SubjectDownMac.asObservable()
            .pipe(
                throttleTime(500)
            ).subscribe(x => this.doSomethingWithThrottledEventDownMac(x));

        this.pageService.callWorkInit.subscribe(resp => {
            if (resp === 'workinit') {
                this.getSingleItem();
            } else {
                this.getWorkItem();
            }
        })
        this.counter = 0;
    }

    getWorkItem() {
        this.route.params.subscribe((params: Params) => {
            this.slug = params['slug'];
            this.wpApi.getWorksItem(this.slug).subscribe(resp => {
                this.handleSingleResponse(resp);
                this.pageService.singleWork(resp[0].title.rendered, resp[0].acf.subtitle);
            });
        });
    }

    getSingleItem() {
        this.route.params.subscribe((params: Params) => {
            this.slug = params['slug'];
            this.wpApi.getWorks().subscribe(resp => {
                this.handleResponse(resp, this.slug);
            });
        });
    }

    handleResponse(resp, slug) {
        const datas = resp;
        for (let index = 0; index < datas.length; index++) {
            const data = datas[index];
            if (slug === data.slug) {
                this.seoService.setSeoMetaTags(data);
                this.title = data.title.rendered;
                this.id = data.id;
                this.subtitle = data.acf.subtitle;
                this.tags = data.acf.tags.split(',');
                this.tagstitle = data.title.rendered;
                this.postColor = data.acf.background_color;
                this.logo = data.acf.logo.url;
                this.image = data.acf.project_modules[0].banner_gallery;
                this.modules = data.acf.project_modules;
                this.pageService.singleWork(data.title.rendered, data.acf.subtitle);

                const modules = data.acf.project_modules;
                this.getPageHeight(modules);
            }
        }
        setTimeout(() => {
            this.animatePage = true;
            this.animateFromRelated = false;
            window.scrollTo(0, 0);
        }, 300);
    }

    handleSingleResponse(resp) {
        this.seoService.setSeoMetaTags(resp[0]);
        this.id = resp[0].id;
        this.title = resp[0].title.rendered;
        this.subtitle = resp[0].acf.subtitle;
        this.tags = resp[0].acf.tags.split(',');
        this.tagstitle = resp[0].title.rendered;
        this.postColor = resp[0].acf.background_color;
        this.logo = resp[0].acf.logo.url;
        this.image = resp[0].acf.project_modules[0].banner_gallery;
        this.modules = resp[0].acf.project_modules;
        const modules = resp[0].acf.project_modules;
        this.getPageHeight(modules);
        setTimeout(() => {
            this.animatePage = true;
            this.animateFromRelated = false;
            window.scrollTo(0, 0);
        }, 300);
    }

    handleScrollPause(event) {
        if (event === 'pause') {
            this.pauseScrollEvent();
        } else {
            this.startScrollEvent();
        }
    }

    pauseScrollEvent() {
        this.pausescroll = true
    }

    startScrollEvent() {
        this.pausescroll = false
    }

    checkDevice() {
        if ((/iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent))) {
            return true;
        } else {
            return false;
        }
    }

    getPageHeight(modules) {
        this.pageCounterValue = 0;
        this.pageCounter = 0;
        for (let i = 0; i < modules.length; i++) {
            if (modules[i].element_size == 6) {
                this.pageCounterValue += 4;
            } else {
                this.pageCounterValue += parseInt(modules[i].element_size);
            }
        }
        if (this.screenWidth > 767) {
            this.pageCounter = Math.floor(this.pageCounterValue / 8);
        } else {
            this.pageCounter = Math.ceil(this.pageCounterValue / 2);
        }
        this.scrollHeight = (this.pageCounter + 2) * this.screenHeight;
    }

    mouseWheelUpFunc(event) {
        event.preventDefault();
        if (this.screenWidth > 1024) {
            if (!(/iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent))) {
                if (this.isMac == 'MacIntel' || this.isMac == 'Mac68K' || this.isMac == 'MacPPC') {
                    if (event.wheelDelta != undefined && event.wheelDelta > 80) {
                        this.SubjectUpMac.next(event);
                    }
                    if (event.detail < -2) {
                        this.SubjectUpMac.next(event);
                    }
                } else {
                    if (event.wheelDelta != undefined && event.wheelDelta > 80) {
                        this.SubjectUp.next(event);
                    }
                    if (event.detail < -2) {
                        this.SubjectUp.next(event);
                    }
                }
            }
        }
    }

    mouseWheelDownFunc(event) {
        event.preventDefault();
        if (this.screenWidth > 1024) {
            if (!(/iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent))) {
                if (this.isMac == 'MacIntel' || this.isMac == 'Mac68K' || this.isMac == 'MacPPC') {
                    if (event.wheelDelta != undefined && event.wheelDelta < -80) {
                        this.SubjectDownMac.next(event);
                    }
                    if (event.detail > 2) {
                        this.SubjectDownMac.next(event);
                    }
                } else {
                    if (event.wheelDelta != undefined && event.wheelDelta < -80) {
                        this.SubjectDown.next(event);
                    }
                    if (event.detail > 2) {
                        this.SubjectDown.next(event);
                    }
                }
            }
        }
    }

    private doSomethingWithThrottledEventUp(event: any) { this.onScrollUp(); }
    private doSomethingWithThrottledEventUpMac(event: any) { this.onScrollUp(); }
    private doSomethingWithThrottledEventDown(event: any) { this.onScrollDown(); }
    private doSomethingWithThrottledEventDownMac(event: any) { this.onScrollDown(); }

    onScrollUp() {
        if (this.pausescroll == false) {
            if (this.counter < -20) {
                this.counter += (this.screenHeight - 10);
            }
            if (this.counter >= -20) {
                this.counter = 0;
            }
        }
    }

    onScrollDown() {
        if (this.pausescroll == false) {
            if (this.counter == 0) {
                this.counter -= (this.screenHeight + 10);
            } else {
                this.counter -= (this.screenHeight - 10);
            }
            if ((this.counter) <= -(this.scrollHeight - this.screenHeight - 10 * (this.pageCounter - 1))) {
                this.counter = -(this.scrollHeight - this.screenHeight - 10 * (this.pageCounter - 1));
            }
            if (this.counter == -(this.screenHeight + 10)) {
                this.pageService.pauseBannerVideo();
                this.bannermodule.resetButton();
            }
        }
    }

    handleRelatedPosts(slug: string) {
        this.activateRelatedOverlay = true;
        window.scrollTo(0, 0);
        this.closeStateActive();
        setTimeout(() => {
            const url = '/' + window.location.pathname.split('/')[1] + '/' + slug;
            this.router.navigate([url]);
            if (this.screenWidth > 1024) {
                document.getElementById('single-grid').classList.remove('transition-grid');
            }
            this.counter = 0;
        }, 200);
        setTimeout(() => {
            document.getElementById('single-grid').classList.add('transition-grid');
            this.animationService.animateImageIndex(0);
        }, 500);
        setTimeout(() => {
            document.getElementsByTagName('body')[0].classList.remove('body-overlay');
            this.pageService.reInitAnimation();
        }, 1000);
    }

    closeStateActive() {
        let workactive = <any>document.querySelector('.post-active .image-wrapper');
        if (workactive) {
            workactive.style.position = '';
            workactive.style.width = '';
            workactive.style.height = '';
            workactive.style.top = '';
            workactive.style.left = '';
            workactive.style.zIndex = '';
            workactive.classList.remove('position-fixed');
        }
    }

    returnIndexItem(index) {
        this.activeindex = index;
    }
}
